export default "__VITE_ASSET__Bfpl3Ncd__"